export enum FORNECEDORES {
	ITAU = 1,
	BRADESCO = 3,
	SANTANDER = 5,
	CAIXA = 25,

	UNKNOW = -1
}
